<template>
  <span
    class="token"
  >
    <!--    <svg v-if="!iconRight" height="16" width="16"> -->
    <!--      <use xlink:href="/icons/sprite.svg#i-token" /> -->
    <!--    </svg> -->
    <img
      v-if="!iconRight"
      alt=""
      src="/img/token.png"
    >

    <span>
      {{ formattedToken }}
    </span>

    <!--    <svg v-if="iconRight" height="16" width="16"> -->
    <!--      <use xlink:href="/icons/sprite.svg#i-token" /> -->
    <!--    </svg> -->
    <img
      v-if="iconRight"
      alt=""
      src="/img/token.png"
    >
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
  tokens: string | number | undefined | null
  decimal?: number
  iconRight?: boolean
}>();

const formattedToken = computed(() => {
  if (
    props.tokens === null
    || props.tokens === undefined
    || Number.isNaN(+props.tokens)
  ) {
    return 'N/A';
  }

  const formattedPrice = +props.tokens / 1000;
  const decimalPlaces = formattedPrice === 0 ? 2 : formattedPrice < 0.1 ? 3 : formattedPrice < 1 ? 2 : (props.decimal ?? 2);

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(formattedPrice).replace(',', '.');
});
</script>

<style lang="scss" scoped>
.token {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  margin: 0;
  color: var(--surfaces-on-surface);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */

  span {
    &:before {
      margin-right: 0.3rem;
    }
  }

  img {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
}
</style>
